import {h} from "./h.js";
import {SiteContents} from "./contents/index.js";
export const SiteBody = /* @__PURE__ */ h(SiteContents, null);
